import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { ContactData } from '../../../../../domain/document.model';
import { ValidationError } from '../../../../../domain/error.model';
import { LsnErrorStateMatcher } from '../../../../shared/middleware/error-state-matcher';
import { DialogAction } from '../../../store/dialog.action';
import { ErrorsState } from '../../../store/errors.state';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';

@Component({
    selector: 'app-contact-data-dialog',
    templateUrl: './contact-data-dialog.component.html'
})
export class ContactDataDialogComponent implements OnInit {

    subscriptions: Subscription[] = [];
    errors: ValidationError[] = [];
    contactData: ContactData;

    matchers = {
        phoneNumber: new LsnErrorStateMatcher(this, 'contactData.phoneNumber'),
        email: new LsnErrorStateMatcher(this, 'contactData.email'),
    };

    constructor(private store: Store,
                @Inject(MAT_DIALOG_DATA) data) {
        this.contactData = cloneDeep(data.contactData);
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(ErrorsState.getAsideErrors).subscribe(errors => this.errors = errors),
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    cancel() {
        this.store.dispatch(new DialogAction.CloseAll());
    }

    save() {
        const offer = this.store.selectSnapshot(OfferState.getOffer);
        this.store.dispatch(new OfferAction.SaveContactData(offer.id, this.contactData));
    }
}
